/* template */
<template minapp="mpx" xlang="wxml"><div class="diamonds-container"><mpx-view v-for="(item, index) in (diamondsList)" :class="(item.gray && 'gray')" @tap="tapDiamond(item)" class="diamond-item"><mpx-image :src="(item.icon)" mode="aspectFit" class="icon" v-if="(item.icon)"/><span class="text" v-if="(item.text)">{{ item.text }}</span><div class="corner-text" v-if="(item.cornerText)">{{ item.cornerText }}</div></mpx-view></div></template>

/* styles */
<style lang="stylus" scoped mpxStyleOptions='{"mid":"m2d8bbd20"}'>
  .diamonds-container
    height 78px
    border-radius 16px
    background #fff
    display flex
    padding 0 12px
    // align-items center
    justify-content space-around
    .diamond-item
      display flex
      align-items center
      flex-direction column
      position relative
      line-height 1
      letter-spacing 0px
      font-weight 400
      margin-top 10px
      .icon
        width 40px
        height 40px
      .text
        font-family PingFang SC
        font-size 12px
        text-align center
        color #666
      .corner-text
        position absolute
        padding 3px 6px
        white-space nowrap
        top 3px
        left 24px
        transform scale(0.5)
        transform-origin left top
        background: #FF4129
        border-radius 12px 12px 12px 2px
        font-family PingFangSC-Medium
        font-size 18px
        color #fff
      &.gray
        opacity 0.3
</style>

/* json */
/* script */
<script>
  import processOption, { getComponent, getWxsMixin } from "@mpxjs/webpack-plugin/lib/runtime/optionProcessor"
  const wxsModules = {}
  global.currentModuleId = "m2d8bbd20"
  global.currentSrcMode = "wx"
  /** script content **/
  require("./index.mpx.js?isComponent&outputPath=components%2Findex2d8bbd20%2Findex!=!@mpxjs/webpack-plugin/lib/selector?mode=web&env=!./index.mpx?ctorType=component&index=0&isComponent&mpx&outputPath=components%2Findex2d8bbd20%2Findex&type=script")
  const currentOption = global.__mpxOptionsMap["m2d8bbd20"]
  export default processOption(
    currentOption,
    "component",
    "",
    "components/index2d8bbd20/index",
    {},
    // @ts-ignore
    {},
    // @ts-ignore
    {'mpx-view':getComponent(require("@mpxjs/webpack-plugin/lib/runtime/components/web/mpx-view.vue?isComponent"), { __mpxBuiltIn: true }),'mpx-image':getComponent(require("@mpxjs/webpack-plugin/lib/runtime/components/web/mpx-image.vue?isComponent"), { __mpxBuiltIn: true })},
    undefined,
    {},
    undefined,
    getWxsMixin(wxsModules)
  )
</script>
